import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme';
import { Query, Resource } from '../../services';
import { AuthContext } from '../../AuthContext';
import { Input } from '@independent-software/typeui/controls/Input';
import { Form } from '@independent-software/typeui/controls/Form';
import { Checkbox } from '@independent-software/typeui/controls/Checkbox';
import { FilterContext } from '../../FilterContext';
import { Label } from '@independent-software/typeui/controls/Label';

interface IProps {
  /** @ignore */
  className?: string;
  label: string;
  factory: Resource<any>,
  selectedItems: number[];
  onChange: (items: number[]) => void;
}

const FilterBoxBase = (props: IProps) => {
  const auth = React.useContext(AuthContext);
  const filter = React.useContext(FilterContext);
  const [q, setQ] = React.useState<string>(null);
  const [items, setItems] = React.useState<any[]>([]);

  React.useEffect(() => {
    const query = new Query('name', 'asc');
    query.setFilter('system', 'in', filter.activeSystems.join(','));
    props.factory.getSome(auth, 0, 999, query)
      .then((res) => setItems(res.items));    
  }, []);

  const handleQ = (value: string) => {
    setQ(value);
  }

  const handleChange = (id: number, value: boolean) => {
    if(!props.selectedItems || props.selectedItems.includes(id)) {
      // Remove parameter from selection:
      props.onChange(props.selectedItems.filter(p => p != id));
    } else {
      // Add parameter to selection:
      props.onChange([id, ...props.selectedItems]);
    }
  }

  const filteredItems = items.filter(p => !q || p.name.toLocaleLowerCase().includes(q.toLocaleLowerCase()));

  return (
    <div className={props.className}>
      <Title>{props.label} <Label size="small">{props.selectedItems.length == 0 ? 'all' : props.selectedItems.length} of {filteredItems.length}</Label></Title>
      <Input icon="search" name="search" fluid clearable value={q} onChange={handleQ}/>
      <List>
        {/* Selected items */}
        {items.filter(p => props.selectedItems.includes(p.id)).map(p => <div key={p.id}>
          <Checkbox label={p.name} checked={props.selectedItems.includes(p.id)} onChange={(value: boolean) => handleChange(p.id, value)}/>
        </div>)}        
        {props.selectedItems.length > 0 && <Separator/>}
        {/* Unselected items */}
        {filteredItems.map(p => <div key={p.id}>
          <Checkbox label={p.name} checked={props.selectedItems.includes(p.id)} onChange={(value: boolean) => handleChange(p.id, value)}/>
        </div>)}
      </List>
    </div>
  )
}

const Title = styled.div`
  font-size: 80%;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
`

const Separator = styled.div`
  border-bottom: solid 1px #ccc;
  height: 6px;
  margin-bottom: 6px;
`

const List = styled.div` 
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
  flex: 1;
  border: solid 1px ${p => p.theme.normalColor};
  padding: 8px;
  border-radius: ${p => p.theme.radius}px;
  margin-top: 8px;
`

const FilterBoxStyled = styled(FilterBoxBase)`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
`

const FilterBox = (props: IProps) => <FilterBoxStyled {...props}/>

export { FilterBox }
